import script from "./MainPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainPage.vue?vue&type=script&lang=ts&setup=true"

import "./MainPage.vue?vue&type=style&index=0&id=1be71713&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be71713"]])

export default __exports__